var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_547)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.32287 0H1.38537C0.621437 0 0 0.621437 0 1.38537V4.94787C0 5.71194 0.621437 6.33338 1.38537 6.33338H7.32287C8.08694 6.33338 8.70838 5.71194 8.70838 4.94787V1.38537C8.70838 0.621437 8.08694 0 7.32287 0Z",
    fill: "#5361DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.32287 7.91663H1.38537C0.621437 7.91663 0 8.53806 0 9.30214V17.6146C0 18.3786 0.621437 19 1.38537 19H7.32287C8.08694 19 8.70838 18.3786 8.70838 17.6146V9.30214C8.70838 8.53806 8.08694 7.91663 7.32287 7.91663Z",
    fill: "#5361DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6145 12.6666H11.677C10.9129 12.6666 10.2915 13.2881 10.2915 14.0521V17.6146C10.2915 18.3786 10.9129 19 11.677 19H17.6145C18.3784 19 18.9999 18.3786 18.9999 17.6146V14.0521C18.9999 13.2881 18.3784 12.6666 17.6145 12.6666Z",
    fill: "#5361DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6145 0H11.677C10.9129 0 10.2915 0.621437 10.2915 1.38537V9.69787C10.2915 10.4619 10.9129 11.0834 11.677 11.0834H17.6145C18.3784 11.0834 18.9999 10.4619 18.9999 9.69787V1.38537C18.9999 0.621437 18.3784 0 17.6145 0V0Z",
    fill: "#5361DC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_547"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.b67da2af365d40052da8aeddc7cb18fe.svg";
export { ForwardRef as ReactComponent };